import { Card, CardBody, Divider } from '@nextui-org/react'
import { FC } from 'react'
import { useTankInfoModalStore } from '../../store/tankInfo/useTankInfoModalStore'
import { schoolCardProps } from '../../types/props/home'
import { CardDetail } from './CardDetail'

export const SchoolCard: FC<schoolCardProps> = ({ tankId, school, tank, ...props }) => {
  const { open, setTank } = useTankInfoModalStore()

  const onOpenTankInfo = () => {
    setTank(tankId, tank?.name || '')
    open()
  }

  // Format start date as YYYY-MM-DD
  // Note: toISOString()은 UTC로 변환되어 시간대 차이로 날짜가 하루 밀릴 수 있음
  const dateString = school?.startDate
    ? (() => {
        const date = new Date(school.startDate)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      })()
    : 'unknown'

  return (
    <Card
      className="
        bg-tdplsky
        w-full md:w-64
        items-center
        border border-tdpldarkgrey/50
        p-2
        relative z-10
        shadow-card
        rounded-lg
      "
      radius="lg"
      style={{ borderRadius: '0.75rem' }}
      isPressable
      onPress={onOpenTankInfo}
      isHoverable
      data-testid={`tank-card-${tankId}`}
      {...props}
    >
      <CardBody>
        <h2 className="font-bold text-tdpldark text-lg md:text-xl">
          {tank?.name}
        </h2>
        <Divider className="my-3 md:my-4 h-px bg-tdpldarkgrey" />
        <CardDetail itemName="AVERAGE WEIGHT" itemDesc={school?.averageWeight} itemUnit="g" />
        <CardDetail itemName="COUNT" itemDesc={school?.count} />
        <CardDetail itemName="TOTAL BIOMASS" itemDesc={school?.totalBiomass} itemUnit="g" />
        <CardDetail itemName="DENSITY" itemDesc={school?.density} itemUnit="g/m³" />
        <CardDetail itemName="MAX DENSITY" itemDesc={tank?.maxDensity} itemUnit="kg/m³" />
        <CardDetail itemName="FEED AMOUNT" itemDesc={school?.feedingRate} itemUnit="kg" />
        <CardDetail itemName="START DATE" itemDesc={dateString} />
      </CardBody>
    </Card>
  )
}
